import {Component} from "react";
import {Col, Container, Modal, ModalBody, ModalHeader, Row} from "reactstrap";
import "./LogInfoModal.css";
import AppLogIcon from "../../../media/app-images/AppLogIcon.mjs";
import TextLabel from "../../../controls/TextLabel/TextLabel.mjs";

const prefix='LogInfoModal';
/**
 * @typedef LogLine
 * @type {Object}
 * @property {number} id
 * @property {number} logtime
 * @property {string} module
 * @property {string} username
 * @property {number} severity
 * @property {any} logdata
 * @property {string} message
 * @property {string} param
 */

const LogInfoModal = class extends Component{
	renderSeverity(sev){
		switch(sev) {
			case 0:
				return 'Info';	
			case 1:
				return 'Warning';
			case 2:
				return 'Error';
			case 3:
				return 'Critical';
			default:
				return null;
		} 
	}
	render() {
		/** @type {LogLine} */
		const log = this.props.log
		const ll = window.document.documentElement.getAttribute('lang') || 'en-GB';
		return (
			<Modal
				className={prefix}
				isOpen={true}
				fade={false}
				size={'lg'}
				toggle={this.props.close}
			>
				<ModalHeader toggle={this.props.close}>
					<AppLogIcon />
					Module: { log.module.toLocaleUpperCase(ll) }
				</ModalHeader>
				<ModalBody>
					<Container>
						<Row>
							<Col>
								<TextLabel value={"Timestamp"} />
							</Col>
							<Col>
								{ new Date(log.logtime).toLocaleString(ll) }
							</Col>
						</Row>
						<Row>
							<Col>
								<TextLabel value={"User"} />
							</Col>
							<Col>
								{ log.username }
							</Col>
						</Row>
						<Row>
							<Col>
								<TextLabel value={"Message"} />
							</Col>
							<Col>
								{ log.message }
							</Col>
						</Row>
						<Row>
							<Col>
								<TextLabel value={"Severity"} />
							</Col>
							<Col>
								{this.renderSeverity(log.severity)}
							</Col>
						</Row>
						<Row>
							<Col>
								<TextLabel value={"Parameter"} />
							</Col>
							<Col>
								{ log.param }
							</Col>
						</Row>
						<Row>
							<Col>
								<TextLabel value={"Module"} />
							</Col>
							<Col>
								{ log.module }
							</Col>
						</Row>
						<Row>
							<Col>
								<TextLabel value={"Data"} />
							</Col>
							<Col>
								{ log.logdata ? JSON.stringify(log,null,2) : '—'}
							</Col>
						</Row>
					</Container>
				</ModalBody>
			</Modal>
		)
	}
}

export default LogInfoModal;